/**
 * @generated SignedSource<<e9014666213c54a5245ce41bc45d3039>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useOrgNodeIdQuery$variables = {
  orgUuid: string;
  skip: boolean;
};
export type useOrgNodeIdQuery$data = {
  readonly organization?: {
    readonly id: string;
  } | null;
};
export type useOrgNodeIdQuery = {
  response: useOrgNodeIdQuery$data;
  variables: useOrgNodeIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgUuid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "uuid",
            "variableName": "orgUuid"
          }
        ],
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useOrgNodeIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useOrgNodeIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f5c4f9d19c21971f810617a10ee806ce",
    "id": null,
    "metadata": {},
    "name": "useOrgNodeIdQuery",
    "operationKind": "query",
    "text": "query useOrgNodeIdQuery(\n  $orgUuid: String!\n  $skip: Boolean!\n) {\n  organization(uuid: $orgUuid) @skip(if: $skip) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "495f815aad6399888ccd4e54f3bc9e00";

export default node;
